import './DonationWidgetFeature.css';
import {
  FiCheckCircle,
  FiCreditCard,
  FiGlobe,
  FiLayout,
  FiMail,
  FiSmartphone,
  FiTrendingUp
} from 'react-icons/fi';

const features = [
  {
    icon: <FiLayout />,
    title: 'Branded Donation Experience',
    copy:
      'Every project receives a professionally branded donation widget customized to their mission, colors, logo, and messaging.'
  },
  {
    icon: <FiCreditCard />,
    title: 'Embedded Website Donations',
    copy:
      'Projects can place their donation experience directly onto their own website while also being listed within our public giving directory.'
  },
  {
    icon: <FiMail />,
    title: 'Automatic Tax Receipting',
    copy:
      'Donors instantly receive professional branded donation receipts suitable for accounting, tax documentation, and donor transparency.'
  },
  {
    icon: <FiTrendingUp />,
    title: 'Fundraising Infrastructure Included',
    copy:
      'Projects receive donation infrastructure without managing payment systems, receipting, compliance, or development internally.'
  }
];

const includedItems = [
  'Branded hosted donation pages',
  'Embedded website donation widgets',
  'Automatic donor tax receipting',
  'Mobile-optimized donation experience',
  'Secure online payment processing',
  'Custom project branding and colors',
  'Professional donor confidence signals',
  'Public listing in our giving directory'
];

const DonationWidgetFeature = () => {
  return (
    <section className="services-widget-section">
      <div className="services-widget-shell">

        <div className="services-widget-intro">
          <div className="services-widget-eyebrow">
            Included With Every Sponsored Project
          </div>

          <h2>
            Every project receives a professionally branded donation experience.
          </h2>

          <p>
            We provide every fiscally sponsored project with custom donation pages,
            embeddable giving widgets, automated donor receipting, and fundraising
            infrastructure designed to increase donor confidence and simplify giving.
          </p>

          <div className="services-widget-pill-row">
            <div className="services-widget-pill">
              <FiLayout />
              <span>Branded Donation Pages</span>
            </div>

            <div className="services-widget-pill">
              <FiCreditCard />
              <span>Embedded Website Widgets</span>
            </div>

            <div className="services-widget-pill">
              <FiMail />
              <span>Automated Tax Receipts</span>
            </div>

            <div className="services-widget-pill">
              <FiSmartphone />
              <span>Mobile Optimized</span>
            </div>
          </div>
        </div>

        <div className="services-widget-showcase-grid">

          <div className="services-widget-demo-card">
            <div className="demo-card-heading">
              <span>LIVE DONATION EXPERIENCE</span>
              <h4>Professionally branded donation page</h4>
              <p>
                Every project receives a fully branded donation experience matching
                their colors, logo, mission, and donor messaging.
              </p>
            </div>

            <div className="services-demo-frame">
              <div className="services-live-widget-sample">

                <div className="services-sample-banner">
                  Sample project donation page — illustrative preview only
                </div>

                <section className="sample-brand-header">
                  <div className="sample-brand-accent"></div>

                  <div className="sample-brand-header-inner">
                    <div className="sample-brand-left">
                      <div className="sample-brand-logo">
                        Your
                        <br />
                        Logo
                      </div>

                      <div className="sample-brand-title-wrap">
                        <span>Your branding colors or hero image</span>
                        <h3 className="sample-brand-title">Your Project</h3>
                        <p>
                          A fiscally sponsored project of Your Organization.
                        </p>
                      </div>
                    </div>

                    <div className="sample-brand-contact">
                      your@email.org
                    </div>
                  </div>
                </section>

                <section className="sample-donation-panel">

                  <div className="sample-amount-grid">
                    <button>$25</button>
                    <button>$50</button>
                    <button className="selected">$100</button>
                    <button>$250</button>
                  </div>

                  <div className="sample-custom-amount-row">
                    <div className="sample-currency-prefix">$</div>
                    <div className="sample-custom-input">
                      Enter custom donation amount
                    </div>
                  </div>

                  <div className="sample-recurring-row">
                    <span>Make this recurring</span>

                    <span className="sample-toggle">
                      <span></span>
                    </span>
                  </div>

                  <div className="sample-cover-fees-row">
                    <span className="sample-checkbox checked"></span>
                    <span>Cover processing fees</span>
                  </div>

                  <div className="sample-fee-summary-box">
                    <div className="sample-fee-summary-row">
                      <span>Intended donation</span>
                      <span>$100.00</span>
                    </div>

                    <div className="sample-fee-summary-row">
                      <span>Processor fee</span>
                      <span>$3.20</span>
                    </div>

                    <div className="sample-fee-summary-row total">
                      <span>Total donor charge</span>
                      <span>$103.20</span>
                    </div>
                  </div>

                  <div className="sample-form-grid">

                    <div className="sample-field">
                      <label>First Name</label>
                      <div>Your First Name</div>
                    </div>

                    <div className="sample-field">
                      <label>Last Name</label>
                      <div>Your Last Name</div>
                    </div>

                    <div className="sample-field full">
                      <label>Company Name</label>
                      <div>Optional</div>
                    </div>

                    <div className="sample-field">
                      <label>Address</label>
                      <div>123 Main Street</div>
                    </div>

                    <div className="sample-field">
                      <label>City</label>
                      <div>Your City</div>
                    </div>

                    <div className="sample-field">
                      <label>Country</label>
                      <div>United States</div>
                    </div>

                    <div className="sample-field">
                      <label>State/Province</label>
                      <div>Your State</div>
                    </div>

                    <div className="sample-field">
                      <label>Postal Code</label>
                      <div>12345</div>
                    </div>

                    <div className="sample-field">
                      <label>Email</label>
                      <div>donor@email.com</div>
                    </div>
                  </div>

                  <div className="sample-action-row">
                    <button>Donate!</button>
                  </div>
                </section>

                <footer className="sample-brand-footer">
                  <div className="sample-brand-accent"></div>

                  <div className="sample-footer-inner">

                    <div className="sample-footer-top">
                      <div>
                        <h3>Your Project</h3>

                        <p>
                          Your project mission statement or donor-facing footer
                          message appears here.
                        </p>
                      </div>

                      <div className="sample-footer-contact">
                        your@email.org
                      </div>
                    </div>

                    <div className="sample-footer-divider"></div>

                    <p className="sample-footer-legal">
                      Your Project is a fiscally sponsored project of Your
                      Organization (EIN: 12-3456789), a nonprofit organization
                      recognized by the IRS as tax-exempt under Section 501(c)(3).
                      Donations are tax-deductible to the extent allowed by law.
                    </p>
                  </div>
                </footer>

              </div>
            </div>
          </div>

          <div className="services-widget-demo-card">
            <div className="demo-card-heading">
              <span>AUTOMATED TAX RECEIPTING</span>

              <h4>Branded donor receipt included</h4>

              <p>
                Donors instantly receive professional branded donation receipts
                suitable for accounting, donor transparency, and tax documentation.
              </p>
            </div>

            <div className="services-demo-frame">
              <div className="services-widget-receipt-sheet">

                <div className="receipt-sample-watermark">
                  SAMPLE PREVIEW
                </div>

                <div className="receipt-sheet-header">

                  <div className="receipt-sheet-brand">
                    <div className="receipt-sheet-logo">
                      Your
                      <br />
                      Logo
                    </div>

                    <div>
                      <h5>Your Organization</h5>

                      <p>EIN: 12-3456789</p>

                      <span>
                        Fiscal Sponsor for <strong>Your Project</strong>
                      </span>
                    </div>
                  </div>

                  <div className="receipt-sheet-title">
                    <h4>Donation Receipt</h4>
                    <p>Sample date</p>
                  </div>
                </div>

                <div className="receipt-sheet-notice">
                  Illustrative sample only. Not a valid receipt.
                </div>

                <table className="receipt-sheet-table">
                  <thead>
                    <tr>
                      <th>Description</th>
                      <th>Designation</th>
                      <th>Amount</th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr>
                      <td>Charitable contribution</td>
                      <td>Your Project</td>
                      <td>$100.00</td>
                    </tr>
                  </tbody>

                  <tfoot>
                    <tr>
                      <td colSpan="2">Total Tax-Deductible Amount</td>
                      <td>$100.00</td>
                    </tr>
                  </tfoot>
                </table>

                <div className="receipt-sheet-grid">

                  <div>
                    <h6>Donor Information</h6>

                    <p className="receipt-sheet-name">
                      Your Donor
                    </p>

                    <p>Donor address shown here</p>
                    <p>donor@email.com</p>
                  </div>

                  <div>
                    <h6>Payment Details</h6>

                    <p>Status: Completed</p>
                    <p>Type: One-time donation</p>
                    <p>Currency: USD</p>
                  </div>
                </div>

                <div className="receipt-sheet-disclosure">
                  Your Project is fiscally sponsored by Your Organization,
                  a nonprofit organization recognized by the IRS as tax-exempt
                  under Section 501(c)(3). Contributions are tax-deductible to
                  the fullest extent allowed by law.
                </div>

                <div className="receipt-sheet-footer">
                  Actual receipts are generated after completed donations.
                </div>
              </div>
            </div>
          </div>

        </div>

       

        <div className="services-widget-included">
          <div>
            <h3>
              Fundraising infrastructure included with sponsorship.
            </h3>

            <p>
              We do not simply provide nonprofit status. We provide operational
              fundraising infrastructure designed to help projects raise money
              professionally and confidently from day one.
            </p>
          </div>

          <ul>
            {includedItems.map((item) => (
              <li key={item}>
                <FiCheckCircle />
                <span>{item}</span>
              </li>
            ))}
          </ul>
        </div>

      </div>
    </section>
  );
};

export default DonationWidgetFeature;